import styled from "styled-components";

export const AccountLink = styled.a`
  border: 2px solid #1e1e1e;
  padding: 10px 44px;
  background-color: transparent;
  background-color: ${(props) => props.btnColor || "transparent"};
  color: ${(props) => props.btnTextColor || "black"};
  border-radius: 67px;
  justify-self: center;
  font-size: 24px;

  &:disabled {
    opacity: 0.3;
  }
  text-decoration: none;
`;
